// src/components/profile/FollowButton.js
import React, { useState, useEffect } from 'react';
import '../../styles/follow-button.css';

const FollowButton = ({ username, isFollowing: initialIsFollowing, onToggle }) => {
  const [isFollowing, setIsFollowing] = useState(initialIsFollowing);
  const [loading, setLoading] = useState(false);
  
  // Update local state when prop changes
  useEffect(() => {
    setIsFollowing(initialIsFollowing);
  }, [initialIsFollowing, username]);
  
  const handleClick = async () => {
    setLoading(true);
    await onToggle();
    setIsFollowing(!isFollowing);
    setLoading(false);
  };
  
  return (
    <button
      className={`follow-button ${isFollowing ? 'following' : ''}`}
      onClick={handleClick}
      disabled={loading}
    >
      {loading ? 'Processing...' : isFollowing ? 'Following' : 'Follow'}
    </button>
  );
};

export default FollowButton;